/** @jsx jsx */
import { jsx } from '@emotion/react';

import { useQuery } from '@apollo/client';

import SkillMasteryLevelsForCurrentUser from 'bundles/levelsets/levelsets-v2/api/SkillMasteryLevelsForCurrentUser.graphql';
import type {
  SkillMasteryLevelsForCurrentUserQuery,
  SkillMasteryLevelsForCurrentUserQueryVariables,
} from 'bundles/levelsets/levelsets-v2/api/__generated__/SkillMasteryLevelsForCurrentUser';
import { LevelSetCard } from 'bundles/levelsets/levelsets-v2/components/LevelSetCard';

type Props = {
  skillId: string;
  skillName: string;
};

export const MasteryLevelBanner = ({ skillId, skillName }: Props) => {
  const { data, loading } = useQuery<
    SkillMasteryLevelsForCurrentUserQuery,
    SkillMasteryLevelsForCurrentUserQueryVariables
  >(SkillMasteryLevelsForCurrentUser, {
    context: { clientName: 'gatewayGql' },
    variables: {
      skillIds: [skillId],
    },
  });
  const skill = { skillId, skillName };

  if (loading) {
    return null;
  }

  const { masteryLevel, masteryPercent } =
    data?.SkillMasteryLevels?.querySkillsMasteryLevels?.elements?.find(
      (skillMastery) => skillMastery.skill.id === skillId
    ) || {};

  return (
    <LevelSetCard skill={skill} masteryLevel={masteryLevel} masteryPercent={masteryPercent} variant="forSkillPage" />
  );
};
